export function updateStateFromState() {
  const { key, value, code } = this.state
  try {
    const res = this.call('updateState')
    this.test('Updating State in data', () => {
      return this.testCase(
        'Value equals root state',
        'isEqualObject',
        this.getState(key),
        value
      )
    })

    if (res?.success) {
      this.call('updateStateOnCanvas', value)
      this.test('Updating State on Canvas', () => {
        return (
          this.testCase(
            'Value equals root state',
            'isEqualObject',
            this.getState(key),
            value
          ) &&
          this.testCase(
            'Value equals Collection state',
            'isEqualObject',
            this.getCanvasCollection().state[key],
            value
          ) &&
          this.testCase(
            'Value equals Collection context',
            'isEqualObject',
            this.getCanvasContext().state[key],
            value
          )
        )
      })
    }
  } catch (e) {
    console.error(e)
  }
}

export function updateState() {
  const { key } = this.state
  try {
    return this.sdk.updateItem(
      'state',
      {
        ...this.state,
        key
      },
      { message: `Updating state ${key}` }
    )
  } catch (err) {
    this.state.update({
      err
    })
  }
}

export function updateStateOnCanvas(obj, type = 'state') {
  // window.requestAnimationFrame(() => {
  const Collection = this.getCanvasCollection()
  const { key } = this.state
  if (Collection) {
    const ctx = Collection.context
    ctx[type][key] = obj
    Collection.state.replace({ [key]: obj })
  } else {
    this.error('Canvas Collection was not found')
  }

  const { chosen } = this.getCanvasScope()
  if (chosen) {
    // TODO: add chosen later!
  }
}

export async function removeState() {
  return this.call('removeItem', 'state', this.state.key)
}
